<template>
    <div class="content-wrapper">
        <div class="content-icon">
            <img src="@/assets/icons/ic_allow.svg">
        </div>
        <div class="content-text">
            <div class="text__title" v-if="$route.query.paid == 'true'">
                {{translate('orderSuccessPayPal')}}
            </div>
            <div class="text__title" v-else>
                {{translate('orderSuccessPayment')}}
            </div>
        </div>
        <div class="content__btn" @click="goToDashboard">
           {{translate('orderBtnToDashboard')}}
        </div>
    </div>
</template>

<script>
    import errorMixin from "@/mixins/errorMixin";

    export default {
        mixins: [errorMixin],
        name: "orderSuccess",
        data() {
            return {

            }
        },
        methods: {
            goToDashboard () {
                this.$router.push({name: 'OwnerPlaceManagement'});
            }
        }
    }
</script>

<style scoped>
    .content__btn {
        cursor: pointer;
        margin-top: 34px;
        background: #3F405C;
        border-radius: 6px;
        padding: 12px 16px;
        font-family: Nunito;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
        color: #ffffff;
    }
    .content-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .content-text {
        margin-top: 25px;
        font-size: 20px;
        line-height: 30px;
        width: 500px;
        text-align: center;
    }
    @media screen and (max-width: 426px) {
        .content-wrapper {
            margin-top: 50px;
        }
        .content-text {
            width: auto;
        }
    }
</style>